import { c as _c } from "react/compiler-runtime";
import { DataList } from '@morpho-org/ui-v6/client';
import { formatters } from '@morpho-org/ui-v6/utils';
import { Fragment, memo } from 'react';
import { RiskCuratorCard } from '@/components/common/RiskCuratorCard';
const aumFormatter = formatters.short.digits(2).unit('$').default('-');
const cursorPointerStyle = {
  cursor: 'pointer'
} as const;
export interface CuratorTvlDataLineProps {
  curators: {
    id: string;
    aum: number | undefined;
    name: string;
    image: string | null;
    verified: boolean;
  }[];
}
const CuratorTvlDataLine = t0 => {
  const $ = _c(15);
  const {
    curators: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? [] : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const curators = t2;
  const hasMultipleCurators = curators.length > 1;
  let t3;
  if ($[2] !== curators || $[3] !== hasMultipleCurators) {
    t3 = hasMultipleCurators ? <>{curators.map((curator, index) => <Fragment key={`curator-name-${curator.name}`}>{curator.name} AUM{index < curators.length - 1 && " / "}</Fragment>)}</> : "Curator TVL";
    $[2] = curators;
    $[3] = hasMultipleCurators;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const curatorLabel = t3;
  let t4;
  if ($[5] !== curators || $[6] !== hasMultipleCurators) {
    t4 = hasMultipleCurators ? curators.map(_temp) : curators[0] && <RiskCuratorCard curator={{
      id: curators[0].id,
      name: curators[0].name,
      image: curators[0].image,
      state: curators[0].aum != null ? {
        aum: curators[0].aum
      } : null
    }} chainId={null}><span className="text-foreground text-xs" style={{
        ...cursorPointerStyle
      }}>{aumFormatter.of(curators[0].aum)}</span></RiskCuratorCard>;
    $[5] = curators;
    $[6] = hasMultipleCurators;
    $[7] = t4;
  } else {
    t4 = $[7];
  }
  const curatorValue = t4;
  let t5;
  if ($[8] !== curatorLabel) {
    t5 = <DataList.LeftItem><span className="text-secondary-foreground text-xs">{curatorLabel}</span></DataList.LeftItem>;
    $[8] = curatorLabel;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  let t6;
  if ($[10] !== curatorValue) {
    t6 = <DataList.RightItem>{curatorValue}</DataList.RightItem>;
    $[10] = curatorValue;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  let t7;
  if ($[12] !== t5 || $[13] !== t6) {
    t7 = <DataList.Line>{t5}{t6}</DataList.Line>;
    $[12] = t5;
    $[13] = t6;
    $[14] = t7;
  } else {
    t7 = $[14];
  }
  return t7;
};
export default memo(CuratorTvlDataLine);
function _temp(curator_0, index_0, array) {
  return <Fragment key={`curator-value-${curator_0.name}`}><RiskCuratorCard curator={{
      id: curator_0.id,
      name: curator_0.name,
      image: curator_0.image,
      state: curator_0.aum != null ? {
        aum: curator_0.aum
      } : null
    }} chainId={null}><span className="text-foreground text-xs" style={{
        ...cursorPointerStyle
      }}>{aumFormatter.of(curator_0.aum)}</span></RiskCuratorCard>{index_0 < array.length - 1 && " / "}</Fragment>;
}